import { Link } from "react-router-dom";
import ContactForm from "@/pages/about/components/ContactForm";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const services = [
  {
    icon: "ri-film-line",
    title: "影视内容聚合",
    desc: "汇集电影、电视剧、综艺等多元类型作品，提供统一入口与清晰的内容组织。",
  },
  {
    icon: "ri-search-eye-line",
    title: "便捷搜索与筛选",
    desc: "支持关键词搜索与类型、年份、地区多维筛选，帮助你快速找到想看的内容。",
  },
  {
    icon: "ri-shield-check-line",
    title: "轻量观看体验",
    desc: "以播放为核心优化浏览路径，详情页直达播放入口，减少操作步骤。",
  },
];

export default function About() {
  useDocumentMeta(
    "关于我们 - 91在线观看视频",
    "了解91在线观看视频的平台定位、服务范围与免责声明，本站为影视内容聚合演示平台，提供清晰的浏览与观看体验。",
    "关于我们,91在线观看视频,影视平台介绍",
  );

  return (
    <div className="mx-auto max-w-6xl px-4 py-8 md:px-8 md:py-12">
      <nav className="mb-5 flex items-center gap-1.5 text-xs text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">关于我们</span>
      </nav>

      <header className="rounded-lg bg-primary-900 px-6 py-10 md:px-10 md:py-14">
        <h1 className="text-2xl font-black text-background-50 md:text-4xl">关于 91在线观看视频</h1>
        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-background-100/80 md:text-base">
          91在线观看视频是一家面向中文用户的影视内容聚合与在线观看平台。我们希望用清晰、专业、易用的方式，
          把电影、电视剧、综艺等类型内容聚合在一起，让你随时随地都能轻松找到并观看喜欢的作品，无需额外下载。
        </p>
      </header>

      <section className="mt-12">
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">服务范围</h2>
        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
          {services.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-12 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
        <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
          <i className="ri-error-warning-line text-accent-600"></i>
          免责声明
        </h2>
        <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-700">
          <p>
            本站为影视内容聚合与界面展示的演示平台，站内所有影视名称、简介、演职人员及相关信息均为虚构示例数据，
            仅用于产品界面与交互演示，不代表任何真实作品。
          </p>
          <p>
            本站不提供、不存储、不传播任何真实的影视视频资源，页面中的“播放”功能仅为前端交互演示。
            如需提供真实的在线播放服务，需另行接入具备合法版权授权的播放接口。
          </p>
          <p>
            用户在本站产生的收藏记录仅保存在本地浏览器中，我们不会收集或上传你的个人浏览数据。
          </p>
        </div>
      </section>

      <section className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.2fr]">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">联系方式</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            如果你对平台有任何建议、合作意向或内容相关问题，欢迎通过以下方式联系我们，我们会认真对待每一条反馈。
          </p>
          <ul className="mt-6 space-y-4">
            <li className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                <p className="text-sm text-foreground-600">support@91-video.example</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-time-line text-lg"></i>
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-900">服务时间</p>
                <p className="text-sm text-foreground-600">每天 09:00 - 22:00</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-customer-service-2-line text-lg"></i>
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-900">留言反馈</p>
                <p className="text-sm text-foreground-600">填写右侧表单，我们会在 1-2 个工作日内回复</p>
              </div>
            </li>
          </ul>
        </div>

        <ContactForm />
      </section>
    </div>
  );
}